import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './documentsblock.module.scss';
import { useState } from 'react';

const ApplicantBlock = () => {
    const { settings } = useAccessibility();

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='СВЕДЕНИЯ ДЛЯ ПОСТУПАЮЩИХ'
            headerColor={textColor}
            id='documents'
            aria-label="сведения для поступающих"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData} role="list">
                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1dSmooPOoDtEEZYxWxFRynhX1Mt-91yBM/view'
                                        children='Устав Организации'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1xJ9LCtZGWeqpZhRZqB2Gh5oULx2ZoMjd/view'
                                        children='Лицензия на осуществление образовательной деятельности'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/drive/folders/1cDzvoge1Zgrx80K6aNx_dvuOfTq_mCCW'
                                        children='Документы, регламентирующие организацию и осуществление образовательной деятельности, права и обязанности обучающихся'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1nAMHAh4gUlsq4P917RMnEM-RO6bxNBFM/view'
                                        children='Система оценок, применяемая при проведении индивидуального отбора'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1PPUKJXGzea8sKBUyoLX5LxBHfaJjvFPu/view'
                                        children='Перечень документов и сведений от поступающих, необходимых для зачисления в ГБУ ДО КК "СШОР "Самбо"'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/15rVsLw1Jvv2l0naBYpaIXf8LRn9Nkf6m/view?usp=sharing'
                                        children='Образцы заявлений о приеме на обучение по дополнительным образовательным программам спортивной подготовки (для совершеннолетних и несовершеннолетних поступающих)'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/drive/folders/1HqIiRidJ2IdSnY2qiGIO0hS-p0EtLkVI'
                                        children='Образцы согласий на обработку персональных данных для АИС "МОЙ СПОРТ"'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1Hikf0E_wb6tODSIs5UFZiEPpfhmtnX5N/view'
                                        children='Нормативы общей физической подготовки и специальной физической подготовки для зачисления на обучение по каждой дополнительной образовательной программе спортивной подготовки'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/10B4M_u2zEJ-hybgDJkzOoXdZwZyk1HRt/view?usp=sharing'
                                        children='Требования, предъявляемые к возрасту и спортивной квалификации поступающих'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1-M2X1-3iP3iW1NLgX8_ViPG-kt7s1SBH/view'
                                        children='Правила подачи и рассмотрения апелляций по процедуре и (или) результатам индивидуального отбора'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>

                        <section 
                            className={style.row}
                            role="listitem"
                        >
                            <div className={style.text} style={{ color: textColor }}>
                                    <Link
                                        href='https://drive.google.com/file/d/1QE2yfqz9CdY5s1IhoZeZIkOYFxcozI2o/view'
                                        children='Государственное задание ГБУ ДО КК "СШОР "Самбо" с 01.06.2025'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1rem'
                                        fontWeight='500'
                                        download
                                    />
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default ApplicantBlock;